// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CiCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/CiCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var CiCircleTwoTone = function CiCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleTwoToneSvg
  }));
};

CiCircleTwoTone.displayName = 'CiCircleTwoTone';
export default React.forwardRef(CiCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CiCircleTwoTone.js
// module id = 769
// module chunks = 0